import { Bot } from "lucide-react";

const providerAssets: Record<string, string> = {
  deepseek: "/ai/deepseek.png",
  doubao: "/ai/doubao.png",
  kimi: "/ai/kimi.svg",
  qwen: "/ai/qwen.png",
  yuanbao: "/ai/yuanbao.png",
};

export function AiProviderIcon({ provider, name, className = "w-5 h-5" }: { provider?: string; name?: string; className?: string }) {
  const source = provider ? providerAssets[provider.toLowerCase()] : "";
  if (!source) return <Bot className={className} aria-hidden="true" />;
  return <img src={source} alt={name ? `${name} 图标` : `${provider} 图标`} className={`${className} rounded object-contain`} />;
}
